import { mapDailyStatisticsDto } from '@features/statistics/api/statisticsMapper'
import type { DailyStatistic } from '@features/statistics/types'
import type { DailyStatisticsDto } from '@shared/api/statistics.dto'
import { useNuxtApi } from '@shared/nuxt/useNuxtApi'

export const statisticsApi = {
  getDailyStatistics() {
    return useNuxtApi<DailyStatisticsDto, DailyStatistic[]>('/api/daily', {
      transform: mapDailyStatisticsDto,
    })
  },
}
